export default function ListTextPreview({ value }) {
  const text = String(value || "").trim();

  if (!text) {
    return "";
  }

  const firstWord = text.split(/\s+/)[0];

  return (
    <span className="list-text-preview">
      <span className="list-text-first-word">{firstWord}</span>
      {text !== firstWord && (
        <span className="list-text-tooltip-wrap">
          <button
            type="button"
            className="list-text-tooltip-trigger"
            aria-label="Vollstaendigen Text anzeigen"
          >
            v
          </button>
          <span className="list-text-tooltip">{text}</span>
        </span>
      )}
    </span>
  );
}
